import { featuresData } from "@/mocks/landingData";

export default function Features() {
  return (
    <section id="features" className="section-padding relative">
      <div className="container-main">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="v2-section-label justify-center">
            <span className="w-8 h-px bg-teal-400" />
            مميزات الخدمة
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mt-4">
            <span className="title-line-1">مميزات تصميم موقعك</span>
            <span className="title-line-2 v2-gradient-text">
              مع أوامر الشبكة
            </span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 auto-rows-fr">
          {featuresData.map((feature, index) => (
            <div
              key={feature.title}
              className="group v2-glass-card-hover p-6 md:p-8 h-full flex flex-col"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-teal-500/20 to-cyan-500/10 border border-teal-400/20 flex items-center justify-center group-hover:scale-110 group-hover:shadow-[0_0_30px_-5px_rgba(45,212,191,0.4)] transition-all duration-500">
                  <i className={`${feature.icon} text-teal-400 text-2xl`} />
                </div>
                <span className="text-4xl font-black text-white/5 group-hover:text-teal-500/10 transition-colors">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2 group-hover:text-teal-200 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed flex-1">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
